import { render, staticRenderFns } from "./mapLiveAction.vue?vue&type=template&id=a6cd74a0&scoped=true"
import script from "./mapLiveAction.vue?vue&type=script&lang=js"
export * from "./mapLiveAction.vue?vue&type=script&lang=js"
import style0 from "./mapLiveAction.vue?vue&type=style&index=0&id=a6cd74a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6cd74a0",
  null
  
)

export default component.exports